/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cdpTrackEventCashDotApp} from '../api'

export const useMutationCdpTrackEventCashDotApp = createReactQueryMutationHook('cdpTrackEventCashDotApp', cdpTrackEventCashDotApp)
